
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M192 176c-17.344 0-32-10.976-32-24s14.656-24 32-24c8.704 0 16.832 2.688 22.848 7.616 6.848 5.568 16.896 4.512 22.528-2.304 5.568-6.848 4.544-16.928-2.304-22.528-7.712-6.272-17.056-10.496-27.072-12.768V80c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.984c-27.52 6.272-48 28-48 54.016 0 30.88 28.704 56 64 56 17.344 0 32 10.976 32 24s-14.656 24-32 24c-8.704 0-16.832-2.688-22.848-7.616-6.88-5.6-16.928-4.544-22.496 2.304-5.6 6.848-4.576 16.928 2.272 22.528 7.712 6.272 17.056 10.496 27.072 12.8V304c0 8.832 7.168 16 16 16s16-7.168 16-16v-17.984c27.52-6.272 48-28 48-54.016 0-30.88-28.704-56-64-56z"}}),_c('path',{attrs:{"d":"M446.752 137.856a15.831 15.831 0 00-3.456-5.184L315.328 4.704a15.831 15.831 0 00-5.184-3.456C308.224.448 306.144 0 304 0H96C78.368 0 64 14.368 64 32v448c0 17.632 14.368 32 32 32h320c17.632 0 32-14.368 32-32V144c0-2.144-.448-4.224-1.248-6.144zM320 54.624L393.376 128H320V54.624zM416 496v-16H96V32h192v96c0 17.632 14.368 32 32 32h96v320h.032L416 496z"}}),_c('path',{attrs:{"d":"M368 224h-64c-8.832 0-16 7.136-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16s-7.168-16-16-16zM368 288h-64c-8.832 0-16 7.136-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16s-7.168-16-16-16zM368 352H144c-8.832 0-16 7.136-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16zM368 416H144c-8.832 0-16 7.136-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16z"}})])
          )
        }
      }
    